import { API } from "../../api/constants"
import { authenticatedAxiosInstance } from "../../auth/AuthenticatedAxios"
import { OrderType } from "../types"

export const addOrderRequest = (data: OrderType) => authenticatedAxiosInstance.post(API + `/portal/orderrequest`, data).then((res) => res.data)

export const getOrdersByCustomer = () => authenticatedAxiosInstance.get(API + `/portal/orderrequest/paginate`).then((res) => res.data)

export const getCustomerSelf = () => authenticatedAxiosInstance.get(API + `/customer-portal/self`).then((res) => res.data)
